module.exports = new __parcel__URL__("volfova_x2.b55476b8.webp").toString();